import {faAd} from '@fortawesome/free-solid-svg-icons';

export const environment = {
  production: false,
  enable_test_ui: false,
  base_url: 'https://api.payarc.io/v1',
  googleAnalyticsId: '',
  branding_manifest_ttl_ms: 300000, // 5 minutes
  branding_url: 'https://payarc-branding-preprod.s3.us-east-2.amazonaws.com/',
};
